import { Link } from "react-router-dom";
import ExpertProductApi from "../../../api/ExpertProductApi";

const CATEGORY_NAME = {
    PCA02: "종합대행",
    PCA03: "블로그",
    PCA04: "플레이스",
    PCA05: "쇼핑",
    PCA06: "체험단",
    PCA07: "SNS",
    PCA08: "카페",
    PCA09: "오프라인",
    PCA10: "검색어광고",
    PCA11: "SNS",
    PCA12: "인플루언서",
    PCA13: "언론뉴스기사",
    PCA99: "기타",
};

const getCategoryName = (value) => {
    return value ? CATEGORY_NAME[value] || "" : "";
};

const ExpertProductListItem = ({ product, onUpdate, isFavoriteOnly = false }) => {
    const handleLikeClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            const result = await ExpertProductApi.toggleLike(product.expert_product_id);
            if (result && result.is_liked !== undefined) {
                onUpdate((prevProducts) =>
                    prevProducts
                        .map((p) =>
                            p.expert_product_id === product.expert_product_id
                                ? {
                                      ...p,
                                      liked_by_me: result.is_liked,
                                      expert_product_like_cnt: result.is_liked
                                          ? p.expert_product_like_cnt + 1
                                          : p.expert_product_like_cnt - 1,
                                  }
                                : p
                        )
                        .filter((p) => (isFavoriteOnly ? p.liked_by_me : true))
                );
            }
        } catch (error) {
            console.error("좋아요 토글 실패:", error);
        }
    };

    return (
        <li>
            <Link to={`/expert/product/${product.expert_product_id}`} className="vertify-card">
                <div className="vertify-card-thumb">
                    <img
                        src={product.expert_product_banner_img || "/static/img/assets/thumb_adv.png"}
                        alt=""
                    />
                    {product.expert_product_type === "EPT02" && (
                        <div className="badge-plan">
                            <span>Plus</span>
                        </div>
                    )}
                </div>
                <div className="vertify-card-desc">
                    <div className="vertify-card-meta">
                        <span>{product.user_nicknm}</span>
                        {/* <i className="icon icon-medal"></i> */}
                        <div
                            className="vertify-card-etc"
                            onClick={handleLikeClick}
                        >
                            <i
                                className={`icon icon-heart${
                                    product.liked_by_me ? "-fill" : ""
                                }`}
                            ></i>
                            <span>{product.expert_product_like_cnt}</span>
                        </div>
                    </div>
                    <h1>{product.expert_product_title}</h1>
                    <div className="vertify-card-price">
                        <p>{product.min_service_price?.toLocaleString()}원~</p>
                    </div>
                    {getCategoryName(product.expert_product_category) && (
                        <span className="vertify-card-badge">
                            {getCategoryName(product.expert_product_category)}
                        </span>
                    )}
                </div>
            </Link>
        </li>
    );
};

export default ExpertProductListItem;
